import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { Button } from 'react-bulma-components';
import TestTubeRack from 'stores/models/TestTubeRack';
import { Colors } from 'utils/Visualization';
import TestTubeTile from './TestTubeTile';

interface IProps {
  isPredicting: boolean;
  onChange: (model: TestTubeRack) => void;
}

interface IState {
  model: TestTubeRack | null;
}

class View extends Component<IProps, IState> {
  private onPredict = () => {
    const model = new TestTubeRack();
    this.setState({ model });

    const { onChange } = this.props;
    onChange(model);
  };

  private onPredictionChange = (cb?: Function) => {
    const { onChange } = this.props;

    if (cb) {
      cb();
    }

    const { model } = { ...this.state };
    if (model) {
      onChange(model);
    }
  };

  private renderPrediction = () => {
    const {
      hasIPTGz,
      hasIPTGa,
      hasONPGz,
      hasONPGa,
      toggleHasIPTGz,
      toggleHasIPTGa,
      toggleHasONPGz,
      toggleHasONPGa,
    } = {
      ...this.state.model,
    };

    return (
      <div className='is-flex is-justify-content-space-between w-100p h-30px'>
        <div className='is-flex-centered is-flex-direction-column'>
          <div className='is-flex'>
            <TestTubeTile
              color={Colors.Yellow}
              isExpressed={hasONPGz}
              onClick={() => this.onPredictionChange(toggleHasONPGz)}
            />
            <TestTubeTile
              color={Colors.Yellow}
              isExpressed={hasIPTGz}
              onClick={() => this.onPredictionChange(toggleHasIPTGz)}
            />
          </div>
        </div>
        <div className='is-flex-centered is-flex-direction-column'>
          <div className='is-flex'>
            <TestTubeTile
              color={Colors.Orange}
              isExpressed={hasONPGa}
              onClick={() => this.onPredictionChange(toggleHasONPGa)}
            />
            <TestTubeTile
              color={Colors.Orange}
              isExpressed={hasIPTGa}
              onClick={() => this.onPredictionChange(toggleHasIPTGa)}
            />
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { isPredicting } = { ...this.props };

    return isPredicting ? (
      this.renderPrediction()
    ) : (
      <Button size='small' onClick={this.onPredict}>
        Predict
      </Button>
    );
  }
}

const TestTubeRackPrediction = observer(View);
export default TestTubeRackPrediction;
